export default __webpack_public_path__ + "static/media/83.d1427b0a.jpg";